// extracted by mini-css-extract-plugin
export default {"root":"Header_root__Jq5+a","title":"Header_title__fmdWr","close":"Header_close__o-k2T","back":"Header_back__EJ+9z","ask":"Header_ask__0hKa-","check":"Header_check__8DwyZ"};